import { useMemo } from 'react'
import { useIntl } from 'react-intl'

import config from 'constants/config'

function useTravelSynonymLabels() {
  const intl = useIntl()
  const travelSynonym = config.brandConfig.travelSynonym

  return useMemo(() => {
    const travelSynonymLabel = travelSynonym === 'holiday'
      ? intl.formatMessage({
          id: 'kj7bAlqlpejLlgX9rOt-',
          defaultMessage: 'holiday',
          description: 'Brand travel synonym interpolated into offer CTAs and headings for white-label holiday brands',
        })
      : intl.formatMessage({
          id: '3x5_LzY0SoynVQGUzjG-',
          defaultMessage: 'package',
          description: 'Brand travel synonym interpolated into offer CTAs and headings for Luxury Escapes package brands',
        })

    return { travelSynonym: travelSynonymLabel }
  }, [intl, travelSynonym])
}

export default useTravelSynonymLabels
